module.exports = __webpack_public_path__ + "static/media/GBL_Stationary_Set_2.17ca0021.jpg";